import { TestDifficulty } from '../types';

export const TEST_DIFFICULTY_OPTIONS: Array<{
  value: TestDifficulty;
  label: string;
}> = [
  { value: 'easy', label: 'Лёгкий' },
  { value: 'medium', label: 'Средний' },
  { value: 'hard', label: 'Сложный' },
];

export const TEST_DIFFICULTY_LABEL: Record<TestDifficulty, string> = {
  easy: 'Лёгкий',
  medium: 'Средний',
  hard: 'Сложный',
};

export const TEST_DIFFICULTY_COLOR: Record<TestDifficulty, string> = {
  easy: 'green',
  medium: 'gold',
  hard: 'red',
};
